module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.target.id) ? [_c('div', {
    staticClass: "target-details__platform"
  }, [_c('div', [_c('div', [_c('b', [_vm._v("Target Name: ")]), _vm._v(_vm._s(_vm.target.display_name))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Advertiser: ")]), _vm._v(_vm._s(_vm.target.advertiser.Name))])])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25ca8670"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/TargetDetails.vue
// module id = 1839
// module chunks = 0